import { gql } from "@apollo/client";

export const GET_SECTORS = gql`
    query getSectors {
        getSectors {
            _id
            sectorName
        }
    }
`;